import React from 'react'
import { Link } from 'react-router-dom'
import AddReview from './AddReview'

class ReviewAddTab extends React.Component {
  state = {
    review_Id: null,
  }

  componentDidMount() {
    if (
      this.props.match.params.id !== undefined &&
      this.props.match.params.id !== null &&
      this.props.match.params.id !== 0 &&
      this.props.match.params.id !== ''
    ) {
      this.setState({ review_Id: this.props.match.params.id })
    }
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      Review
                      {this.state.review_Id ? ' Edit' : ' Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin-review">Admin Reviews</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Review
                      {this.state.review_Id ? ' Edit' : ' Add'}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane active"
                        role="tabpanel"
                      >
                        {this.state.review_Id !== undefined &&
                          this.state.review_Id !== null &&
                          this.state.review_Id !== 0 &&
                          this.state.review_Id !== '' ? (
                          <AddReview
                            goBack={this.props.history.goBack}
                            review_Id={this.state.review_Id}
                          />
                        ) : (
                          <AddReview goBack={this.props.history.goBack} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReviewAddTab
